// Fetches the global 5.0 plan catalog. Shared by useProposalCatalog (Proposal
// Tool) and usePurchaseLinkCatalog (Create Purchase Link flow) so both
// flows call the exact same two endpoints instead of duplicating the fetch.
export async function fetchProductConfig(client) {
  const [all5PlanPrices, defaultPlanConfig] = await Promise.all([
    client('plans/5/v1/list').catch(() => null),
    client('plans/config/default').catch(() => null),
  ])

  return {all5PlanPrices, defaultPlanConfig}
}
